var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"d-none",style:('height: 1px;'),attrs:{"id":"list-filter-position"}},[_c('v-col')],1)}
var staticRenderFns = []

export { render, staticRenderFns }